import CartItem from './CartItem'

export { CartItem }



// WEBPACK FOOTER //
// ./src/features/Cart/components/index.js